import { Mark } from '../../../../node_modules/tiptap/dist/tiptap.esm.js';
import { alignment } from '../../../../node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/alignment.js';

/* eslint-disable */
class Alignment extends Mark {
  get name() {
    return 'alignment';
  }

  get schema() {
    return { ...alignment,

      toDOM(mark) {
        return ['div', {
          class: `fabric-editor-block-mark fabric-editor-align-${mark.attrs.align}`,
          'data-align': mark.attrs.align,
          style: 'text-align: ' + mark.attrs.align
        }, 0];
      }

    };
  }

}

export default Alignment;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/marks/Alignment.js